import { reactive, readonly } from 'vue'
import Swal from 'sweetalert2'

interface Identity {
	id?: string
	phone?: string
	name?: string
	avatar?: string
	defaultBranch?: number
	hasPSID?: boolean
	pageId?: string
	isRegistered: boolean
}

window.identity = reactive<Identity>(Object.assign({
	isRegistered: false,
}, window.identity || {}))

const identity = window.identity as Identity

const fetchAvatar = (accessToken : string) => new Promise<string>((resolve, reject) => {
	FB.api('/me/picture?redirect=false', { access_token: accessToken }, (response : any) => {
		if (response.error) {
			return reject(response.error.message)
		}

		resolve(response.data.url)
	})
})

const fetchIdentity = (accessToken : string) => new Promise<void>((resolve) => {
	FB.api('/me', { access_token: accessToken }, async (response : any) => {
		if (!response.error) {
			console.log('Successful login for: ' + response.name)

			identity.id = response.id
			identity.name = response.name
			identity.avatar = await fetchAvatar(accessToken)

			Object.assign(identity, await fetchIdentityFromAPI(identity))
		} else {
			// TODO: send error log to FB_Sentry

			if (response.error.code == 4) {
				Swal.fire({
					title: '喔噢',
					text: '系統出錯 (Error: 4)',
					icon: 'error',
				})
			} else {
				Swal.fire({
					title: `喔噢 (${response.error.code})`,
					text: '系統出錯 ' + response.error.message,
					icon: 'error',
				})
			}
		}

		resolve()
	})
})

const fetchIdentityFromAPI = async ({ id, name } : Identity) => {
	const url = new URL(`${api_base_url}/facebook/api/register`)
	const params = new URLSearchParams({ id, name })
	url.search = params.toString()

	const response = await fetch(url.href, {
		credentials: 'include',
	})
	const json = await response.json()

	return {
		isRegistered: json.is_registered,
		phone: json.CustomerPhone,
		defaultBranch: json.CustomerDefaultBranch,
		hasPSID: json.hasPSID,
		pageId: json.page_id,
	}
}

const registerIdentity = async ({ phone, defaultBranch } : Partial<Identity>) => {
	const params = {
		asid: identity.id,
		CustomerName: identity.name,
		CustomerDefaultBranch: defaultBranch,
		CustomerFacebookID: "",
		CustomerLINEID: "",
		CustomerPhone: phone,
	}

	let json = { success: false }
	try {
		const response = await fetch(`${api_base_url}/facebook/api/customer`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(params),
		})
		json = await response.json()
	} catch (e) {

		throw new Error('發生錯誤！(registerIdentity POST)')
	}

	if (!json.success) {
		throw new Error('發生錯誤！(registerIdentity POST)')
	}

	const { phone: phoneFromAPI, isRegistered, defaultBranch: defaultBranchFromAPI, hasPSID } = await fetchIdentityFromAPI(identity)
	identity.phone = phoneFromAPI
	identity.isRegistered = isRegistered
	identity.defaultBranch = defaultBranchFromAPI
	identity.hasPSID = hasPSID
}

const updateIdentity = async ({ branch } : { branch: number }) => {
	const params = {
		asid: identity.id,
		branch,
	}

	let json = { success: false }
	try {
		const response = await fetch(`${api_base_url}/facebook/api/updateCustomerBranch`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(params),
		})
		json = await response.json()
	} catch (e) {

		throw new Error('發生錯誤！(updateCustomerBranch)')
	}

	if (!json.success) {
		throw new Error('請再試一次或聯絡客服進行修改')
	}

	identity.defaultBranch = branch
}

export {
	fetchIdentity as setup,
	registerIdentity,
	updateIdentity,
}
export const useIdentity = () => readonly(identity)
